
export const StartFixedNumberExceptions = [
  "0230"
];
